var $bab267b77ddeadf8$exports = {};
$bab267b77ddeadf8$exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};


export {$bab267b77ddeadf8$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
